<template>
  <v-footer
      color="#3cbc62"
      app
      class="footer-font"
  >
    <span class="white--text">&copy; 2019 - {{ new Date().getFullYear() }}. Todos os direitos reservados.</span> 
    <v-spacer></v-spacer>
    <span class="white--text">UP - Tecnologia em sistemas - v1.0.2 | Contato suporte: <a href="//api.whatsapp.com/send?phone=+5515991665796&text=Olá, estou com uma dúvida sobre o sistema SIGU" target="_blank" rel="noopener noreferrer" class="font-weight-medium white--text" title="Contato Suporte">(15) 99166-5796</a></span>
  </v-footer>
</template>
<script>
export default {
}
</script>

<style>

  .footer-font{
    font-size: 0.8rem
  }

</style>